


const DivArr = (props) => {

    let { arr } = props

    return (<div className="divArr__container">
        {
            props.type === 'checkbox'
                ? !!props.options && props.options.map(opt => {
                    return (
                        <div className="fl-rw divArr__div" key={opt}>
                            <input className="divArr__checkbox"
                                checked={arr.includes(opt)}
                                name={opt}
                                onChange={(e) => props.handleArr({ target: props.father, checkbox: { [opt]: e.target.checked } })}
                                type='checkbox'
                                value={opt}
                            />
                            <label>{opt}</label>
                        </div>
                    )
                })
                : !!arr.length && <div className="categories__container__optionSelected">{arr.map((current, i) => {
                    return (
                        <div className="categories__optionSelected" key={current}>{current} <span style={{ "cursor": "pointer" }} onClick={() => props.handleArr({ target: props.father, i })} >| x</span></div>
                    )
                })}
                </div>
        }
    </div>)

}


export default DivArr